import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useLogout from './hooks/useLogout';

const propTypes = {
  className: PropTypes.string,
  redirectUrl: PropTypes.string,
  disabled: PropTypes.bool,
  onDisabledClick: PropTypes.func,
  icon: PropTypes.node,
};

const LogoutLink = ({
  className,
  redirectUrl,
  disabled,
  onDisabledClick,
  icon,
}) => {
  const { loading, logout } = useLogout();
  const opts = redirectUrl && { redirectUrl };

  const classes = classNames({
    [className]: !!className,
    disabled,
  });

  return (
    <a
      href="#"
      className={classes}
      onClick={async event => {
        event.preventDefault();

        if (disabled) {
          if (onDisabledClick) {
            onDisabledClick();
          }

          return;
        }

        await logout(opts);
      }}
    >
      {icon}
      {loading ? 'Logging out...' : 'Log Out'}
    </a>
  );
};

LogoutLink.propTypes = propTypes;

export default LogoutLink;
